
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityMergePriorityGrid extends SiteEntityGrid<SecurityMergePriorityRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMergePriority'; }
        protected getDialogType() { return SecurityMergePriorityDialog; }
        protected getIdProperty() { return SecurityMergePriorityRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergePriorityRow.localTextPrefix; }
        protected getService() { return SecurityMergePriorityService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.frozenColumn = 3;
            return opt;
        }

        getPropertyItems() {
            var items = super.getPropertyItems();
            for (var item of items)
                if (item.formatterType == "Checkbox" &&
                    !item.alignment) {
                    item.alignment = "center";
                    if (!item.headerCssClass)
                        item.headerCssClass = "align-center";
                }
            return items;
        }
    }
}